import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";
import * as R from 'ramda';
export const distributionSupplierState = {
    distributionSupplierData: null,
    supplierList: null,
    supplierDetails: null,
}

